<template>
    <splash v-show="isLoading" :title="props.title + ' 준비중...'" />
    <splash v-show="isProc" title="잠시만 기다려 주세요." />
    <!-- <studyHeader v-if="!isLoading" /> -->
    <customHeader
        v-if="!isLoading"
        :title="props.title"
        @onClickBack="
            () => {
                emit('onClickEnd', null);
            }
        "
    />
    <q-page-container v-if="!isLoading">
        <q-page class="q-pa-md" style="height: calc((var(--vh, 1vh) * 100) - 150px)">
            <div class="row">
                <div class="col passage" style="height: calc((var(--vh, 1vh) * 100) - 70px)">
                    <qbankHeaderVue
                        :questionHeader="questionHeader"
                        :inputIdx="inputIdx"
                        :bookNm="bookNm"
                        @isChangeHeader="
                            () => {
                                isChangeHeader = true;
                            }
                        "
                    />
                </div>
                <div class="col answer" style="height: calc((var(--vh, 1vh) * 100) - 70px)">
                    <q-scroll-area v-if="!relationDialog" ref="scrollAreaRef" visible class="answer__scroll" style="height: 100%">
                        <div>
                            <!-- <problemChoice :p-content="problem" :isCsat="props.type === 'SAT'" v-if="problem" @setAnswer="setAnswer" /> -->
                            <problemChoice :p-content="problem" v-if="problem" @setAnswer="setAnswer" />
                        </div>
                        <!-- 정답표기 -->
                        <!-- <div>{{
                                problems[problemOrder]?.data.content.solution.answer.detail[0].answer
                        }}
                        </div> -->
                        <div>
                            <qbankAnswer :p-content="problem" v-if="isScored && problem?.data && problem?.result && problem?.result?.marking !== 'halfWrong'" @onIntersection="onIntersection" @setVideoStatus="setVideoStatus" />
                        </div>
                    </q-scroll-area>
                    <div v-if="relationDialog">
                        <ProblemRelation
                            :p-content="problem"
                            v-if="problem"
                            @setRelationAnswer="setRelationAnswer"
                            @onClose="
                                () => {
                                    relationDialog = false;
                                }
                            "
                            @setMessage="
                                (m) => {
                                    msg = m;
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </q-page>
        <FloatingNotify
            :text="msg"
            :icon="msgIcon"
            @resetMsg="
                () => {
                    msg = '';
                }
            "
        />
        <!-- <FloatingBtn :visible="nextBtn && !complete" @on-click="() => { nextBtnAction(); }" class="answer--next" /> -->
        <FloatingBtn
            :visible="nextBtn"
            :text="nextBtn && isCompleteBtn ? '완료' : null"
            :bgColor="nextBtn && isCompleteBtn ? '#222222' : null"
            :icon="nextBtn && isCompleteBtn ? 'done' : null"
            @on-click="
                () => {
                    nextBtn && nextBtnAction();
                }
            "
            :class="nextBtn && isCompleteBtn ? 'answer--txt' : 'answer--next'"
        />
        <FloatingBtn
            :visible="preBtn"
            position="left"
            @on-click="
                () => {
                    preBtn && nextStep(false);
                }
            "
            class="answer--prev"
        />
        <FloatingBtn
            :visible="scoreBtn"
            text="정답 확인"
            text-only="true"
            bgColor="#FF4E7C"
            @on-click="
                () => {
                    scoreBtn && setQuestionsResult();
                }
            "
            bottom="calc( 20vh - 55px )"
            class="answer--txt"
        />
    </q-page-container>
</template>

<script setup>
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch, defineProps } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';
import problemChoice from '@/components/qbank/problemChoice.vue';
import qbankAnswer from '@/components/qbank/qbankAnswer.vue';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
import studyHeader from '@/components/layouts/header/studyHeader.vue';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import { getHeaderTitle, getKreadScore, getHeaderText, getEtcInfo, getHeader } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter } from 'vue-router';
import cqBtn from '@/components/quasar/cqBtn.vue';
import _ from 'lodash';
import { analysis, difficult, drill } from '@/helpers/qbankParser/qbankMeta';
import { getAnswer, postAnswer, postCornerEnd } from '@/api/modules/study';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import customHeader from '@/components/layouts/header/header.vue';
import ProblemRelation from '@/components/qbank/problemRelation.vue';
import { useLocalLog } from '@/helpers/utils';

// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(false);
const title = ref('심화학습');
const data = ref(null);
const diffTime = ref(null);
let startTime;
let baseTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false; // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiType = ref('first');
let isScored = false;
let isDrill = false;
let isAllChecked = false;

const relationDialog = ref(false);
const scrollAreaRef = ref(null);

const nextBtn = ref(false);
const preBtn = ref(false);
const scoreBtn = ref(false);
const msgComp = ref(false);
const msg = ref('');
const msgIcon = ref(null);
const isChangeHeader = ref(false);
const isCompleteBtn = ref(false);

let isViewMode = false;

let cornerLearningBaseTime = null;
let cornerTime = {
    passageReadStartTs: null,
    passageReadEndTs: null,
    passageReadTime: 0,
    videoViewStartTs: null,
    videoViewEndTs: null,
    videoViewTime: 0,
    cornerLearningStartTs: null,
    cornerLearningEndTs: null,
    cornerLearningTime: 0,
};

const props = defineProps({
    problemIds: {
        default: [],
    },
    type: {
        default: 'wrong',
    },
    title: {
        default: '오답노트 준비중...',
    },
    examName: {
        default: '',
    },
    isLastExam: {
        default: false,
    },
    exprVersion: {
        default: '1.00.01',
    },
    problemsOrderObject: {
        default: {},
    },
});

const isLast = () => {
    // if (isDrill && (Object.keys(problems).length) === problemOrder.value) {
    //     if (!relationDialog.value && problems[(problemOrder.value)]?.result?.marking === 'wrong' && problems[(problemOrder.value)].relationId !== null) {
    //         return isCompleteBtn.value = false;
    //     } else {
    //         return props.isLastExam ? isCompleteBtn.value = true : isCompleteBtn.value = false;
    //     }
    // } else {
    //     if (problemOrder.value === 4 && Object.keys(drillProblems).length === 0 && props.isLastExam) {
    //         return isCompleteBtn.value = true;
    //     }
    //     return isCompleteBtn.value = false;
    // }
    // console.log('isLast');
    // console.log(Object.keys(problems).length);
    // console.log(problemOrder.value);
    // console.log(props.isLastExam);
    log && console.log('==isLast');
    log && console.log('==isLast, Object.keys(problems).length : ', Object.keys(problems).length);
    log && console.log('==isLast, problemOrder.value : ', problemOrder.value);
    if (Object.keys(problems).length === problemOrder.value) {
        log && console.log('==isLast, 마지막 문제일때');
        if (!relationDialog.value && problems[problemOrder.value]?.result?.marking === 'wrong' && problems[problemOrder.value].relationId !== null) {
            log && console.log('==isLast, 확인문제가 있고, 오답인 경우 완료 btn false ');
            // console.log('isLast1');
            return (isCompleteBtn.value = false);
        } else {
            log && console.log('==isLast, 확인문제가 없거나, 정답인 경우');
            log && console.log('==isLast, 마지막 exam이면 props.isLastExam, completebtn true 아님 false : ', props.isLastExam);
            // console.log('isLast2');
            return props.isLastExam ? (isCompleteBtn.value = true) : (isCompleteBtn.value = false);
        }
    } else {
        log && console.log('==isLast, 마지막 문제가 아닐때');
        // console.log('isLast3');
        return (isCompleteBtn.value = false);
    }
};

const emit = defineEmits(['onClickEnd']);

const initCoreReading = (rs, sdata) => {
    isLoading.value = false;
    const tmpEtcInfo = getEtcInfo(rs);
    data.value = {
        content: getHeaderText(rs),
        kread: tmpEtcInfo.kread,
        title: tmpEtcInfo.title,
        etcInfo: tmpEtcInfo,
        standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
        solveTime: tmpEtcInfo.solveTime,
    };
    questionHeader.value = getHeader(rs);
    bookNm.value = tmpEtcInfo.bookNm;
    startTime = moment();
    cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
    cornerLearningBaseTime = moment();
    problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    // setTimeout(() => {
    //     msg.value = '1번부터 4번까지 문제를 풀어보아요.';
    // }, 1000)
};

/* LOG 셋팅, local 일때만 로그 */
let log = useLocalLog();

const nextStep = (v = true, no = -1) => {
    isProc.value = true;
    soundEffect('next');
    // console.log(problems[(problemOrder.value)]);

    log && console.log('==nextStep');
    log && console.log('==nextStep, isNext=> v, no : ', v, no);
    log && console.log('==nextStep, problemOrder.value : ', problemOrder.value);
    log && console.log('==nextStep, problems : ', problems);
    log && console.log('==nextStep, problems[problemOrder.value] : ', problems[problemOrder.value]);
    log && console.log('==nextStep, problems[problemOrder.value]?.result?.marking : ', problems[problemOrder.value]?.result?.marking);
    log && console.log('==nextStep, problems[problemOrder.value].relationId : ', problems[problemOrder.value].relationId);
    log && console.log('==nextStep, relationDialog.value : ', relationDialog.value);
    log &&
        console.log(
            '==nextStep, isNext && !relationDialog.value && problems[problemOrder.value]?.result?.marking === wrong && problems[problemOrder.value].relationId !== null : ',
            v && !relationDialog.value && problems[problemOrder.value]?.result?.marking === 'wrong' && problems[problemOrder.value].relationId !== null,
        );

    log && console.log('==nextStep, problemsOrderObject : ', props.problemsOrderObject);

    // if (v && !relationDialog.value && !problems[(problemOrder.value)].completeYn && problems[(problemOrder.value)]?.result?.marking === 'wrong' && problems[(problemOrder.value)].relationId !== null) {
    if (v && !relationDialog.value && problems[problemOrder.value]?.result?.marking === 'wrong' && problems[problemOrder.value].relationId !== null) {
        log && console.log('== earnest ==>확인 문제 띄우기');
        isProc.value = false;
        preBtn.value = false;
        nextBtn.value = false;
        if (!problems[problemOrder.value]['completeYn']) {
            setTimeout(() => {
                msgIcon.value = '';
                msg.value = '문제를 잘 이해했는지 다시 한 번 점검해 보세요.';
            }, 500);
            isProc.value = false;
        }
        return (relationDialog.value = true);
    }
    if (!v && relationDialog.value) {
        log && console.log('== earnest ==>확인 문제 열렸을때 다음 문제로 넘어가거나 닫기');
        problem.value = problems[problemOrder.value];
        notiType.value !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        log && console.log('== earnest ==>확인 문제, notiType', notiType.value);
        // notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
        nextBtn.value = true;
        // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
        isCompleteBtn.value = false;
        //로딩중 방지
        if (isProc.value) isProc.value = false;
        // 오답노트이고, 첫문제 일때 prevBtn 비활성화
        props.type === 'NORMAL' && isFirstProblem(problems[problemOrder.value]['problemId']);
        return (relationDialog.value = false);
    }
    if (relationDialog.value) {
        log && console.log('== earnest ==> 확인문제가 활성화 되었을 경우 닫기');
        // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
        relationDialog.value = false;
    }

    if (!isScored && !isDrill && no == -1 && problems[problemOrder.value] && problems[problemOrder.value]['result'] === null) {
        log && console.log('== earnest ==>정답확인');
        problems[problemOrder.value]['elapsedTime'] = problems[problemOrder.value]['elapsedTime'] + moment.duration(moment().diff(startTime)).asSeconds();
        problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    startTime = moment();
    if (no == -1 && problems[problemOrder.value] && problems[problemOrder.value]['result'] !== null && problems[problemOrder.value]['result']['marking'] !== 'halfWrong') {
        //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
        log && console.log('== earnest ==>정답 마킹 완료');
        problems[problemOrder.value]['completeYn'] = true;
    }

    if (notiType.value === 'last' && v) {
        if (isDrill) {
            // submitAnswer(problemOrder.value);
            return saveResult();
            // return router.push('/vocabularylearning');
        } else {
            // submitAnswer(problemOrder.value);
            return saveResult();
            // return router.push('/authenticreading');
        }
    }
    // if (no === -1) {
    //     submitAnswer(problemOrder.value);
    // }

    if (no !== -1) {
        problemOrder.value = no;
    } else if (!v) {
        if (problemOrder.value === 1 && isDrill) {
            log && console.log('== earnest ==>첫번째 문제에서 이전버튼 클릭시');
            title.value = '본격독해';
            isLoading.value = true;
            drillProblems = problems;
            problems = baseProblems;
            problem.value = problems[4];
            isScored = true;
            isDrill = false;
            notiType.value = 'last';
            problemOrder.value = 4;
            setTimeout(() => {
                isLoading.value = false;
            }, 1000);
        } else {
            log && console.log('== earnest ==>이전버튼 클릭시');
            log && console.log('== earnest ==>이전버튼 클릭시, problemOrder.value : ', problemOrder.value);
            log && console.log('== earnest ==>이전버튼 클릭시, problems[problemOrder.value] : ', problems[problemOrder.value]);
            problemOrder.value !== 1 && (problemOrder.value -= 1);
        }
    } else {
        log && console.log('== earnest ==>다음버튼 클릭시');
        problemOrder.value = problemOrder.value + 1;
    }
    // console.log(problemOrder.value);
    // console.log(problems[problemOrder.value]);
    if (!problems[problemOrder.value]['answerStartTs']) {
        log && console.log('== earnest ==>다음문제 시작시간');
        problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    }

    log && console.log('== earnest ==>다음문제로 넘어가기');
    questionHeader.value === null && getHeader(problems[problemOrder.value].data);
    if (problemOrder.value === 1) {
        log && console.log('== earnest ==>첫번째 문제로 넘어가기');
        if (isDrill && Object.keys(problems).length === 1) {
            log && console.log('== earnest ==>첫번째 문제로 넘어가기, 드릴이고 문제가 1개일때 noti는 last');
            notiType.value = 'last';
        } else {
            log && console.log('== earnest ==>첫번째 문제로 넘어가기, noti는 first');
            notiType.value = 'first';
        }
        log && console.log('모달 닫기');
        store.openModal(false);
        // questionHeader.value = getHeader(problems[(problemOrder.value)].data);
    } else if (problemOrder.value === Object.keys(problems).length) {
        log && console.log('== earnest ==>마지막 문제로 넘어가기');
        notiType.value = 'last';
    } else {
        log && console.log('== earnest ==>중간 문제로 넘어가기');
        notiType.value = 'middle';
    }
    // problemOrder.value = problemOrder.value = 2;
    // getKrtProblem({
    //   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
    // }, setProblem)
    problem.value = {
        ...problems[problemOrder.value],
    };
    log && console.log('== earnest ==>다음문제로 넘어가기, problemOrder.value : ', problemOrder.value);

    if (problems[problemOrder.value].result?.marking === 'halfWrong') {
        log && console.log('== earnest ==>다음문제로 넘어가기, 1차오답');
        msgIcon.value = '';
        // msg.value = '오답은 한 번 다시 풀어보아요.';
        msg.value = '다시 한 번 풀어 보세요.';
    }
    if (isDrill && !problems[problemOrder.value]['completeYn']) {
        log && console.log('== earnest ==>다음문제로 넘어가기, 드릴문제 면서 채점이 안된 문제');
        if (problems[problemOrder.value]['problemClassCode'] === '2') {
            log && console.log('== earnest ==>다음문제로 넘어가기, 드릴문제 면서 채점이 안된 문제, 드릴업');
            // msgIcon.value = 'img:/assets/images/icon/drill_up.svg';
            // msg.value = '드릴업되어 ' + (difficult[problems[problemOrder.value].etcInfo.difficultCd].label) + '문제가 나왔어요.';
            msg.value = '기준문제 결과에 따른 드릴문제를 풀어 보세요.';
        } else {
            log && console.log('== earnest ==>다음문제로 넘어가기, 드릴문제 면서 채점이 안된 문제, 드릴다운');
            // msgIcon.value = 'img:/assets/images/icon/drill_down.svg';
            // msg.value = '드릴다운되어 ' + (difficult[problems[problemOrder.value].etcInfo.difficultCd].label) + '문제가 나왔어요! ';
            msg.value = '기준문제 결과에 따른 드릴문제를 풀어 보세요.';
        }
    }

    if (problems[problemOrder.value]['completeYn']) {
        log && console.log('== earnest ==>다음문제로 넘어가기, 채점이 완료된 문제');
        notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
        nextBtn.value = true;
    } else if (isDrill && !problems[problemOrder.value]['completeYn']) {
        log && console.log('== earnest ==>다음문제로 넘어가기, 드릴문제 면서 채점이 안된 문제');
        preBtn.value = false;
        nextBtn.value = false;
        // scoreBtn.value = true;
    } else if (problems[problemOrder.value]['answer'] !== null && !isScored) {
        log && console.log(' == > 다음문제로 넘어가기, 정답확인 전');
        notiType.value !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        notiType.value !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
    } else if (!problems[problemOrder.value]['completeYn'] || isScored) {
        log && console.log('== earnest ==>다음문제로 넘어가기, 채점이 완료된 문제');
        preBtn.value = false;
        nextBtn.value = false;
    } else {
        log && console.log('== earnest ==>다음문제로 넘어가기, 채점이 완료된 문제2');
        notiType.value !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        notiType.value !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
    }
    // console.log(problems[problemOrder.value]);
    // setNotiNavigation(problems[problemOrder.value]);

    // notiNav !== null && notiNav();
    // notiNavBack !== null && notiNavBack();
    // notiNav = null;
    // notiNavBack = null;
    // startTime = moment();

    setScrollPosition();
    isLast();
    isProc.value = false;
};

const initExams = async () => {
    // TODO: store 에 코어리딩 문제 저장
    // rs.examMaps
    log && console.log('== earnest ==>initExams props:');
    log && console.log(props);
    if (props.problemIds && props.problemIds.length > 0) {
        log && console.log('prolemIds : ', props.problemIds);
        let problemArrId = props.problemIds;
        await Promise.all(
            problemArrId.map((item, index) => {
                return getKrtProblem(
                    {
                        version: item.exprVersion,
                        problemId: item.problemId,
                        // version: '1.00.01', problemId: 382222
                    },
                    (r) => {
                        let pData = {
                            examName: item.examName,
                            // problemNo: index + 1,
                            problemNo: props?.num ? props?.num : analysis[r.content.property.analysis.analysisId]['ord'],
                            problemId: r.content.problemId,
                            analysisOrd: item.analysisOrd,
                            etcInfo: getEtcInfo(r),
                            data: r,
                            elapsedTime: 0,
                            answer: null,
                            reAnswer: null,
                            videoTime: 0,
                            relationResult: null,
                            // 하단 네비 조정을 위한 변수
                            result: null, // 채점 여부및 1,2차 정오답
                            completeYn: false, // 채점및 풀이 확인 완료여부
                            scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
                            relationId: r.content.property.problem?.relations?.length > 0 ? r.content.property.problem?.relations[0].relationId : null, // 확인 문제 있는지 여부
                            // relationId: null,           // 확인 문제 있는지 여부
                            completeVideo: false, // 영상 시청 여부
                            correct: r.content.solution.answer.detail[0].answer,
                            // TODO: 큐뱅크 해설영상 파싱필요
                            // videoUrl: null,              // 해설 영상 여부
                            videoUrl: r.content.property.problem.listen.includes('mp4') ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
                            // videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
                            // videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
                            problemClassCode: '1',
                            answerStartTs: null,
                        };

                        problems = {
                            // ...problems, [item.analysisOrd]: pData
                            ...problems,
                            [index + 1]: pData,
                        };

                        if (index === 0) {
                            initCoreReading(r);
                        }
                    },
                );
            }),
        );

        problem.value = problems[1];
        log && console.log('== earnest ==>initExams, problems : ', problems);
        problemOrder.value = 1;
        if (Object.keys(problems).length === 1) {
            log && console.log('== earnest ==>initExams, 문제가 1개일때');
            notiType.value = 'last';
            log && console.log(props);
        } else {
            log && console.log('== earnest ==>initExams, 문제가 1개가 아닐때');
            notiType.value = 'first';
        }
    }
};

onMounted(() => {
    // console.log(props.type);
    soundEffect('enter');
    isLoading.value = true;
    setTimeout(() => {
        initExams();
    }, 1000);
});

onUnmounted(() => {
    isLoading.value = true;
    store.openModal(false);
});

watch(
    () => props.problemIds,
    (newValue) => {
        isLoading.value = true;
        scoreBtn.value = false;
        preBtn.value = false;
        nextBtn.value = false;
        setTimeout(() => {
            initExams();
        }, 1000);
    },
);

//TEST: 테스트용
// watch([() => preBtn.value, () => notiType.value], ([newPreBtn, newNotiType], [oldPreBtn, oldNotiType]) => {
//     log && console.log(`preBtn 변경됨: ${oldPreBtn} -> ${newPreBtn}`);
//     log && console.log(`notiType 변경됨: ${oldNotiType} -> ${newNotiType}`);
// });
// watch(
//     () => problemOrder.value,
//     (newValue) => {
//         log && console.log(`problemOrder 변경됨: ${newValue}`);
//     },
// );

const setAnswer = (val) => {
    log && console.log('== earnest ==>setAnswer val: ', val);
    if (problems[problemOrder.value]?.result !== null) {
        problems[problemOrder.value]['reAnswer'] = val;
        // console.log(problems[problemOrder.value]['reAnswer']);
        scoreBtn.value = true;
    } else {
        problems[problemOrder.value]['answer'] = val;
        scoreBtn.value = true;
    }
};

const setRelationAnswer = (val, isComplete = false) => {
    log && console.log('== earnest ==>setRelationAnswer');
    if (!isComplete) {
        log && console.log('== earnest ==>setRelationAnswer, 확인문제 답안 입력');
        problems[problemOrder.value]['completeYn'] = true;
        problems[problemOrder.value]['relationResult'] = val;
        problem.completeYn = true;
        problem.relationResult = val;
    }
    isLast();
    preBtn.value = true;
    nextBtn.value = true;
};

const nextBtnAction = () => {
    if (notiType.value === 'last' && isScored && !isDrill && Object.keys(drillProblems).length > 0) {
        drillInit();
    } else {
        if (isScored) {
            // problems[problemOrder.value]['completeYn'] = true;
        }
        nextStep();
    }
};

const setQuestionsResult = () => {
    // soundEffect('next');
    // notiAdditionalNav = null;
    log && console.log('== earnest ==>setQuestionsResult');
    log && console.log('== earnest ==>setQuestionsResult, problems[problemOrder.value] : ', problems[problemOrder.value]);

    if (problems[problemOrder.value]['result'] !== null) {
        log && console.log('== earnest ==>setQuestionsResult, 채점이 완료된 문제');
        soundEffect(problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer ? 'correct' : 'wrong');
        problems[problemOrder.value]['result'] = { marking: problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer ? 'halfRight' : 'wrong', answer: problems[problemOrder.value].answer };
        problem.value = { ...problems[problemOrder.value] };
        log && console.log('== earnest ==>setQuestionsResult, problems[problemOrder.value].result : ', problems[problemOrder.value].result);
    } else {
        log && console.log('== earnest ==>setQuestionsResult, 채점이 안된 문제');
        isAllChecked = false;
        if (problems[problemOrder.value]['result'] === null) {
            problems[problemOrder.value]['elapsedTime'] = problems[problemOrder.value]['elapsedTime'] + moment.duration(moment().diff(startTime)).asSeconds();
            problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        startTime = moment();
        const tmpData = [];
        const tmpIsRight = problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].answer;
        problems[problemOrder.value].result = { marking: tmpIsRight ? 'right' : 'halfWrong', answer: problems[problemOrder.value].answer };
        log && console.log('== earnest ==>setQuestionsResult, problems[problemOrder.value].result : ', problems[problemOrder.value].result);
        isScored = true;
        problem.value = { ...problems[problemOrder.value] };
        if (problems[problemOrder.value].data.content.solution.answer.detail[0].answer !== problems[problemOrder.value].answer) {
            msgIcon.value = '';
            // msg.value = '오답은 한 번 다시 풀어보아요.';
            msg.value = '다시 한 번 풀어 보세요.';
            // $q.notify({
            //   message: '오답은 한 번 다시 풀어보아요.',
            //   // color: 'secondary',
            //   position: 'right',
            //   timeout: 1000
            // })
        }
    }
    log && console.log('== earnest ==>setQuestionsResult, problems[problemOrder.value] : ', problems[problemOrder.value]);
    scoreBtn.value = false;
    preBtn.value = false;
    nextBtn.value = false;
    isLast();
    log && console.log('== earnest ==>setQuestionsResult, preBtn : ', preBtn.value);
};

// 스크롤 하단시 액션
const onIntersection = () => {
    log && console.log(' onIntersection !!!!!!!!!!!!!!!');
    log && console.log(' onIntersection, problems[problemOrder.value] : ', problems[problemOrder.value]);
    log && console.log('problemOrder.value : ', problemOrder.value);
    log && console.log('==nextStep, problemsOrderObject : ', props.problemsOrderObject);

    if (problems[problemOrder.value]['scrollCheck'] !== true) {
        log && console.log('scrollCheck 가 false 일때   !!!!!!!!!!!!!!!');
        problems[problemOrder.value]['scrollCheck'] = true;
        if (problem.value?.result?.marking === 'right') {
            log && console.log('scrollCheck 가 false 일때, 정답일때   !!!!!!!!!!!!!!!');
            log && console.log('scrollCheck 가 false 일때, 정답일때, ', notiType.value);
            problems[problemOrder.value]['completeYn'] = true;
            problems[problemOrder.value]['completeVideo'] = true;
            notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
            nextBtn.value = true;
        } else if (problem.value?.result?.marking === 'halfRight') {
            log && console.log('scrollCheck 가 false 일때, 2차 정답일때   !!!!!!!!!!!!!!!');
            log && console.log('scrollCheck 가 false 일때, 2차 정답일때, ', notiType.value);
            if (problems[problemOrder.value]['videoUrl'] === null) {
                problems[problemOrder.value]['completeYn'] = true;
                problems[problemOrder.value]['completeVideo'] = true;
                notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                nextBtn.value = true;
            } else {
                msgIcon.value = '';
                // msg.value = '확인해야 할 해설영상이 있어요!';
                msg.value = '문제풀이 영상을 확인하세요.';
            }
        } else {
            log && console.log('scrollCheck 가 false 일때, 2차 오답일때   !!!!!!!!!!!!!!!');
            if (problems[problemOrder.value]['videoUrl'] !== null) {
                msgIcon.value = '';
                // msg.value = '확인해야 할 해설영상이 있어요!';
                msg.value = '문제풀이 영상을 확인하세요.';
            } else if (problems[problemOrder.value]['videoUrl'] === null && problems[problemOrder.value]['relationId'] === null) {
                log && console.log('scrollCheck 가 false 일때, 2차 오답일때, 확인문제가 없을때   !!!!!!!!!!!!!!!');
                problems[problemOrder.value]['completeYn'] = true;
                notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                nextBtn.value = true;
            } else {
                log && console.log('scrollCheck 가 false 일때, 2차 오답일때, 확인문제가 있을때   !!!!!!!!!!!!!!!');
                notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                log && console.log(props.type);
                nextBtn.value = true;
            }
        }
        // setNotiNavigation(problems[problemOrder.value]);
    }
    log && console.log(notiType.value);
    log && console.log(preBtn.value);
    //위에 로직과 관계없이 첫문제일땐 preBtn이 false
    log && console.log(problems[problemOrder.value]['problemId']);
    //오답노트에서만 problemsOrderObject가 있음, 심화노트는 없음
    props.type === 'NORMAL' && isFirstProblem(problems[problemOrder.value]['problemId']);
};

const isFirstProblem = (problemId) => {
    if (!problemId) return;
    const { problemsOrderObject } = props;
    const index = problemsOrderObject[problemId]['index'];
    if (index === 0) {
        log && console.log('첫문제이다!! preBtn false');
        preBtn.value = false;
    } else {
        hasPreviousVocaProblem(problemId);
    }
};

const hasPreviousVocaProblem = (problemId) => {
    const { problemsOrderObject } = props;
    const index = problemsOrderObject[problemId]['index'];

    for (const key in problemsOrderObject) {
        if (problemsOrderObject[key]['index'] === index - 1) {
            if (problemsOrderObject[key]['type'].slice(-1) === 'W') {
                log && console.log('이전문제가 voca 문제다, make preBtn false');
                preBtn.value = false;
                return;
            }
        }
    }
    preBtn.value = true;
};

const setVideoStatus = () => {
    // console.log('video complete');
    problems[problemOrder.value]['completeVideo'] = true;
    if (problems[problemOrder.value]['relationId'] === null) {
        problems[problemOrder.value]['completeYn'] = true;
        notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
    }
    notiType.value !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
    nextBtn.value = true;
    // setNotiNavigation(problems[problemOrder.value]);
    // console.log(problems[problemOrder.value]);
};

const setScrollPosition = (val = 0) => {
    try {
        scrollAreaRef.value.setScrollPosition('vertical', 0);
    } catch (error) {
        //
    }
};

const drillInit = () => {
    title.value = '드릴학습';
    isLoading.value = true;
    baseProblems = problems;
    problems = drillProblems;
    problem.value = drillProblems[1];
    // isScored = false;
    isDrill = true;
    notiType.value = 'first';
    // submitAnswer(4, 'base');
    nextStep(false, 1);
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
    // problemOrder.value = 1;
};

const saveResult = () => {
    log && console.log('==saveResult');
    isProc.value = true;
    Object.values(problems).forEach((tmpVal) => {
        tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
        tmpVal.correctYn = tmpVal.result === null ? null : tmpVal.result?.marking === 'right';
        tmpVal.reCorrectYn = tmpVal.reAnswer === null ? null : tmpVal.result?.marking === 'halfRight' ? true : false;
        tmpVal.answerStatus = 'COMPLETE';
        // tmpVal.elapsedTime = parseInt(tmpVal.elapsedTime);

        delete tmpVal.data;
        delete tmpVal.result;

        delete tmpVal.problemNo;
        delete tmpVal.analysisOrd;
        delete tmpVal.etcInfo;
        delete tmpVal.videoTime;
        delete tmpVal.relationResult;
        delete tmpVal.scrollCheck;
        delete tmpVal.relationId;
        delete tmpVal.completeVideo;

        delete tmpVal.videoUrl;
        delete tmpVal.completeVideo;
    });
    emit('onClickEnd', problems);
    // if (isViewMode) {
    //     router.push('/vocabularylearning');
    //     studyStore.currentInfo.studyTree = studyStore.currentInfo.studyTree + 1;
    // } else {
    //     postCornerEnd({
    //         type: 'earnest', data: {
    //             examName: studyStore.process.exam.examCode + '_C',
    //             learningType: studyStore.process.exam.learningType
    //         }
    //     }, () => {
    //         router.push('/vocabularylearning');
    //         studyStore.process.studyTree = studyStore.process.studyTree + 1;
    //         // postUserJson(JSON.stringify(studyStore.process), (rs) => {
    //         //   //
    //         // });
    //     })
    // }
};

// const submitAnswer = (num, target = null) => {
//     let tmpVal = { ...problems[num] };
//     if (target === 'drill') {
//         tmpVal = { ...drillProblems[num] }
//     }
//     if (target === 'base') {
//         tmpVal = { ...baseProblems[num] }
//     }
//     if (tmpVal) {

//         tmpVal.answer = tmpVal.answer;
//         tmpVal.reAnswer = tmpVal.reAnswer ? tmpVal.reAnswer : null;
//         tmpVal.elapsedTime = tmpVal.elapsedTime;
//         tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
//         tmpVal.correctYn = tmpVal.result === null ? null : (tmpVal.result?.marking === 'right');
//         tmpVal.reCorrectYn = tmpVal.reAnswer === null ? null : tmpVal.result?.marking === 'halfRight' ? true : false;
//         tmpVal.answerStatus = isScored ? 'COMPLETE' : 'NOT_SCORE';

//         delete tmpVal.data;
//         delete tmpVal.result;
//         delete tmpVal.rightAnswer;

//         delete tmpVal.problemNo;
//         delete tmpVal.analysisOrd;
//         delete tmpVal.etcInfo;
//         delete tmpVal.videoTime;
//         delete tmpVal.relationResult;
//         delete tmpVal.scrollCheck;
//         delete tmpVal.relationId;
//         delete tmpVal.completeVideo;

//         delete tmpVal.videoUrl;
//         delete tmpVal.completeVideo;

//         const saveData = {
//             examName: studyStore.process.exam.examCode + '_R',
//             exprVersion: studyStore.exprVersion,
//             learningType: studyStore.process.exam.learningType,
//             cornerTime: {
//                 cornerLearningStartTs: cornerTime.cornerLearningStartTs,
//                 cornerLearningEndTs: moment().format('YYYY-MM-DD HH:mm:ss'),
//                 cornerLearningTime: (moment.duration(moment().diff(moment(cornerTime.cornerLearningStartTs))).asSeconds())
//             },
//             submission: { ...tmpVal }
//         }
//         console.log('saveData %%%%%%%%%%%%%%%%%%%%%%%%%');
//         console.log('saveData :' + saveData);
//         console.log(JSON.stringify(saveData));
//         if (!isViewMode) {
//             // postAnswer({ type: 'earnest', data: saveData }, () => {
//             //     console.log('save Answer!');
//             // });
//         }

//         cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
//     }
// }
</script>

<style scoped lang="scss">
.word-chart_item {
    padding: 0px 20px;
    text-align: center;
}

.q-dialog__backdrop {
    width: 100vw;
    height: 100vh;
    top: 0px;
    position: fixed;
    z-index: 6000;
    pointer-events: all;
    outline: 0;
    background: rgb(23 20 20 / 40%);
}
.passage {
    + .answer {
        &::before {
            content: '';
            position: absolute;
            top: 46%;
            left: 0;
            width: 1px;
            height: 91%;
            max-height: 974px;
            background: $color_gray_500;
            @include transform(translateY(-50%));
        }
    }
}

.answer {
    position: relative;
    // padding: 0 4.17vmin;

    &__scroll {
        padding: 0 5.17vmin 3.33vmin 4.08vmin;
        // padding-right: 5.17vmin;
        // padding-bottom: 3.33vmin;
    }
}

::v-deep {
    .q-scrollarea__content {
        padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
